import { resolvedOfferConfigSchema } from "@redotech/order-tracking-common/offer-network/offer-placement";
import { trackingPageSettingsSchema } from "@redotech/order-tracking-common/tracking-page-definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getTrackingPage = {
  name: "getTrackingPage" as const,
  input: z.object({
    orderId: zExt.objectId().optional(),
    trackingCode: z.string().optional(),
  }),
  output: z.object({
    trackingPage: z
      .object({
        id: zExt.objectId(),
        teamId: zExt.objectId(),
        settings: trackingPageSettingsSchema,
        createdAt: z.string(),
        updatedAt: z.string(),
      })
      .nullable(),
    // Client-safe SDK config for OFFERS blocks, keyed by offerPlacementId.
    resolvedOffers: z.record(z.string(), resolvedOfferConfigSchema).optional(),
    success: z.boolean(),
  }),
};
